import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'
import { YChildrenComponent } from '../y-children/y-children.component';
import { StatusSignupComponent } from '../status-signup/status-signup.component';


@Component({
  selector: 'app-additional-details',
  templateUrl: './additional-details.component.html',
  styleUrls: ['./additional-details.component.css']
})
export class AdditionalDetailsComponent implements OnInit {

  public userIdWithhoutSignup;
  
  public young_children;
  public veteran_status;
  public income_status;
  public senior_status;
  public disability_status;
  public health_insuarance_status;
  public discrimination_status;
  public saveSearchDatResp;
  public currentUser;
  public userSignup;

  additionalDetailsForm = this
    .formBuilder
    .group({
      // search_term: [
      //   '', Validators.required
      // ],
      // pincode: [
      //   '', Validators.required
      // ]
    });

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
  }
  
  saveStatusDetails(){

    let userId ;
    this.currentUser =  JSON.parse(localStorage.getItem('currentUser'));
    this.userIdWithhoutSignup = localStorage.getItem('userIdWithhoutSignup');
    this.userSignup = localStorage.getItem('user_id');

    if(this.currentUser != null && this.currentUser != undefined){
       userId = this.currentUser.data.user_id
    }
    else if (this.userIdWithhoutSignup != null && this.userIdWithhoutSignup !=undefined){
      userId = this.userIdWithhoutSignup
    }
    else if (this.userSignup != null && this.userSignup != undefined){
      userId = this.userSignup
    }
    else {
      userId = null;
    }

    this.young_children =  JSON.parse(localStorage.getItem('young_children'));
    this.veteran_status =  JSON.parse(localStorage.getItem('veteran_status'));
    this.income_status =  JSON.parse(localStorage.getItem('income_status'));
    this.senior_status =  JSON.parse(localStorage.getItem('senior_status'));
    this.disability_status =  JSON.parse(localStorage.getItem('disability_status'));
    this.health_insuarance_status =  JSON.parse(localStorage.getItem('health_insuarance_status'));
    this.discrimination_status =  JSON.parse(localStorage.getItem('discrimination_status'));
    let foodServicePincode = localStorage.getItem('EservicePincode');
    let foodService = localStorage.getItem('Eservice');
    let tax = localStorage.getItem('tax');


    if(userId != null && userId != undefined){

      if(this.young_children != null && this.veteran_status != null
        && this.income_status != null &&
       this.senior_status != null && this.disability_status != null
       ){
 
         let input  : {}
         input = {
           user_id : userId ,
           no_of_children : this.young_children.noOfChildren,
           child_1_age : this.young_children.childAge1,
           child_2_age : this.young_children.childAge2,
           child_3_age : this.young_children.childAge3,
           veteran_status : this.veteran_status,
           income_status : this.income_status,
           senior_status : this.senior_status,
           disability_status : this.disability_status,
           health_insuarance_status : this.health_insuarance_status ? this.health_insuarance_status : 0,
           discrimination_status : 0
 
         }
         this.commonService.saveSearchData(input).subscribe(res => {
           this.saveSearchDatResp = res.body.data;
           console.log(res,'save search details');
 
           if(this.veteran_status === 0 || this.senior_status === 0 ){
             this.router.navigate(['/feedback'])
           } 
           else if(foodService != null && foodServicePincode != null) {
             this.router.navigate(['/food-service'])
           }
          
           else {
               if(tax == "true"){
            this.router.navigate(['/tax-assistamce'])
            } else {
              this.router.navigate(['/food'])

            } 
           }
 
         }, err => console.error( 'Save Search Data Failed' + err))
       }
       else {
         alert("Please fill all the required details");
         console.log("Please fill all the required details")
       }
    } 
    else{
      this.router.navigate(['/login'])
    }
  }

  
  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  openDialog(action: any, obj: any, element: any) {
    const dialogConfig = new MatDialogConfig();
    obj.action = action;
    if (element != null) {
      obj.id = element;
    }
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = obj;
    let dialogRef;
    if (action === 'yChildren') {
      dialogRef = this.dialog.open(YChildrenComponent, dialogConfig);
    }
    if(action == 'veteran') {
      dialogRef = this.dialog.open(StatusSignupComponent,dialogConfig);
    }
    if(action == 'incomeTax') {
      dialogRef = this.dialog.open(StatusSignupComponent,dialogConfig);
    }
    if(action == 'senior') {
      dialogRef = this.dialog.open(StatusSignupComponent,dialogConfig);
    }
    if(action == 'disability') {
      dialogRef = this.dialog.open(StatusSignupComponent,dialogConfig);
    }
    if(action == 'healthInsurance') {
      dialogRef = this.dialog.open(StatusSignupComponent,dialogConfig);
    }
    if(action == 'discrimination') {
      dialogRef = this.dialog.open(StatusSignupComponent,dialogConfig);
    }
    
  
    dialogRef.afterClosed().subscribe(result => {
      // alert('response: ' + result)
      if (result.event === 'yChildren' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful', 'announcement');
      }
      if (result.event === 'veteran' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful successful', 'announcement');
      }
      if (result.event === 'incomeTax' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful successful', 'announcement');
      }
      if (result.event === 'senior' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful successful', 'announcement');
      }
      if (result.event === 'disability' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful', 'announcement');
      }
      if (result.event === 'healthInsurance' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful successful', 'announcement');
      }
      if (result.event === 'discrimination' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful successful', 'announcement');
      }
      
  
    });
  }

  showNotification(from, align, color, stringMessage, icons) {
    const type = ['', 'info', 'success', 'warning', 'danger'];
  
  
  
    // $.notify({
    //   icon: icons,
    //   message: stringMessage
  
    // }, {
    //   type: type[color],
    //   timer: 4000,
    //   placement: {
    //     from: from,
    //     align: align
    //   },
    //   template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
    //     '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
    //     '<i class="material-icons" data-notify="icon">notifications</i> ' +
    //     '<span data-notify="title">{1}</span> ' +
    //     '<span data-notify="message">{2}</span>' +
    //     '<div class="progress" data-notify="progressbar">' +
    //     '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
    //     '</div>' +
    //     '<a href="{3}" target="{4}" data-notify="url"></a>' +
    //     '</div>'
    // });
  }
}
